module.exports = __webpack_public_path__ + "img/complete-by.32222250.svg";